var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAvailableInventory = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 44C26.3512 44 30.6047 42.7097 34.2225 40.2923C37.8404 37.8749 40.6602 34.439 42.3253 30.419C43.9905 26.3991 44.4261 21.9756 43.5773 17.708C42.7284 13.4404 40.6331 9.52041 37.5563 6.44366C34.4796 3.3669 30.5596 1.27161 26.292 0.422734C22.0244 -0.426141 17.6009 0.00953237 13.581 1.67466C9.56099 3.33979 6.12506 6.15958 3.70767 9.77746C1.29028 13.3953 0 17.6488 0 22C0 27.8348 2.31785 33.4305 6.44365 37.5564C10.5694 41.6821 16.1652 44 22 44Z",
    fill: "#EFF7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9673 32.6854H8.03685C7.57616 32.6854 7.13433 32.5024 6.80857 32.1766C6.48281 31.8508 6.2998 31.409 6.2998 30.9483V18.8569H37.7034V30.9483C37.7035 31.1764 37.6587 31.4022 37.5715 31.613C37.4843 31.8237 37.3564 32.0152 37.1952 32.1765C37.034 32.3379 36.8426 32.4658 36.6319 32.5531C36.4212 32.6404 36.1953 32.6854 35.9673 32.6854Z",
    fill: "#CAE4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0805 30.1716H10.9198C10.7842 30.1687 10.6539 30.1184 10.5515 30.0295C10.4491 29.9405 10.3811 29.8186 10.3593 29.6847L8.81065 21.4682C8.79195 21.3826 8.7923 21.294 8.81165 21.2086C8.831 21.1231 8.86889 21.043 8.92264 20.9738C8.97639 20.9046 9.04468 20.8481 9.12268 20.8083C9.20068 20.7684 9.28649 20.7462 9.37404 20.7432H34.6262C34.7135 20.7466 34.799 20.7691 34.8766 20.8092C34.9543 20.8492 35.0222 20.9058 35.0757 20.9749C35.1291 21.044 35.1667 21.124 35.1859 21.2092C35.2051 21.2945 35.2054 21.3829 35.1867 21.4682L33.6381 29.6847C33.6163 29.8181 33.5487 29.9397 33.4469 30.0286C33.3452 30.1174 33.2155 30.168 33.0805 30.1716Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2579 22H20.7432V24.5147H23.2579V22Z",
    fill: "#118AF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2579 26.3999H20.7432V28.9146H23.2579V26.3999Z",
    fill: "#118AF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6583 26.3999H25.1436V28.9146H27.6583V26.3999Z",
    fill: "#118AF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0577 26.3999H29.543V28.9146H32.0577V26.3999Z",
    fill: "#118AF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8584 26.3999H16.3438V28.9146H18.8584V26.3999Z",
    fill: "#118AF9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4581 26.3999H11.9434V28.9146H14.4581V26.3999Z",
    fill: "#118AF9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8584 22H16.3438V24.5147H18.8584V22Z",
    fill: "#118AF9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0577 22H29.543V24.5147H32.0577V22Z",
    fill: "#118AF9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6583 22H25.1436V24.5147H27.6583V22Z",
    fill: "#118AF9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4581 22H11.9434V24.5147H14.4581V22Z",
    fill: "#118AF9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29688 18.8578L12.1259 12.2578C12.2134 12.1589 12.3209 12.0797 12.4413 12.0255C12.5616 11.9712 12.6921 11.9432 12.8242 11.9431H31.175C31.3071 11.943 31.4377 11.971 31.5581 12.0252C31.6785 12.0795 31.7859 12.1588 31.8733 12.2578L37.7081 18.8578H6.29688Z",
    fill: "#118AF9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8936 11.9432L18.1433 9.12431C18.2174 9.02557 18.313 8.94504 18.4229 8.88885C18.5328 8.83265 18.6541 8.80228 18.7775 8.80005H25.1288C25.2484 8.80236 25.3661 8.83118 25.4733 8.88444C25.5805 8.9377 25.6745 9.01407 25.7486 9.10805L28.1093 11.9432H15.8936Z",
    fill: "#118AF9"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAvailableInventory, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/available-inventory.1f6f984c.svg";
export { ForwardRef as ReactComponent };